import { useEffect, useState, type ReactNode } from 'react';
import QRCode from 'qrcode';

/**
 * QR code do link direto da sala.
 * O valor codificado fica exposto em `data-qr-value` para inspeção e testes.
 */
export function QrCode({ value, size = 260 }: { value: string; size?: number }): ReactNode {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setFailed(false);

    QRCode.toDataURL(value, {
      errorCorrectionLevel: 'M',
      margin: 2,
      width: size * 2,
      color: { dark: '#0a0e1a', light: '#ffffff' },
    })
      .then((url) => {
        if (active) setDataUrl(url);
      })
      .catch(() => {
        if (active) setFailed(true);
      });

    return () => {
      active = false;
    };
  }, [value, size]);

  if (failed) {
    return (
      <p className="rounded-2xl bg-night-900 p-4 text-center text-sm break-all text-night-300">
        {value}
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <div
        className="rounded-3xl bg-white p-3"
        style={{ width: size + 24, height: size + 24 }}
        data-testid="qr-container"
      >
        {dataUrl ? (
          <img
            src={dataUrl}
            alt={`QR code para ${value}`}
            width={size}
            height={size}
            data-testid="qr-image"
            data-qr-value={value}
            className="size-full"
          />
        ) : (
          <div className="size-full animate-pulse rounded-2xl bg-night-200" />
        )}
      </div>
      <p className="text-center text-xs break-all text-night-400" data-testid="qr-value">
        {value}
      </p>
    </div>
  );
}
